import { Drawer, type DrawerProps } from 'antd';
import React from 'react';

export interface BaseDrawerProps extends DrawerProps {
  content?: React.ReactNode;
}

const BaseDrawer: React.FC<BaseDrawerProps> = (props) => {
  const { open, width = 420, content, ...others } = props;

  return (
    <Drawer open={open} width={width} destroyOnClose footer={null} {...others}>
      {content}
    </Drawer>
  );
};
export default BaseDrawer;
